<template>
  <div>
    <div>
      <img src="/static/img/banner.png" style="width: 100%" />
    </div>
    <el-container style="background: #f5f7fd">
      <el-header
        style="width: 100%; max-width: 1170px; margin: auto; overflow: hidden"
      >
        <div style="float: left; margin-left: 22px">
          <h3
            :style="
              global.isPhone
                ? 'font-size: 16px; line-height: 60px'
                : 'font-size: 19px; line-height: 60px'
            "
          >
            查询结果:[<span style="display: inline; color: red">{{
              restext
            }}</span
            >]
          </h3>
        </div>
        <div style="float: right; margin-right: 16px">
          <el-link type="primary" href="/">继续查询</el-link
          ><i class="el-icon-arrow-right"></i>
        </div>
        <el-divider></el-divider>
      </el-header>
    </el-container>
    <el-container style="background: #f5f7fd">
      <el-header style="height: 0px"></el-header>
      <el-main
        style="width: 100%; max-width: 1170px; margin: auto; overflow: hidden"
        v-if="result"
      >
        <el-card class="box-card">
          <el-descriptions
            title="企业信息"
            :column="2"
            :border="true"
            :direction="global.isPhone() ? 'vertical' : ''"
          >
            <el-descriptions-item label="企业名称" span="2">{{
              cert.companyname
            }}</el-descriptions-item>
            <el-descriptions-item label="信用代码">{{
              cert.socilacredit
            }}</el-descriptions-item>
            <el-descriptions-item label="法定代表人">
              {{ cert.legalperson }}</el-descriptions-item
            >
            <el-descriptions-item label="经营范围" span="2">{{
              cert.registeredaddress
            }}</el-descriptions-item>
          </el-descriptions>
        </el-card>
        <el-card class="box-card" style="margin-top: 15px">
          <el-descriptions
            title="证书信息"
            :column="2"
            :border="true"
            :direction="global.isPhone() ? 'vertical' : ''"
          >
          <el-descriptions-item label="证书名称">{{
              cert.certname
            }}</el-descriptions-item>
           <el-descriptions-item label="证书编号">{{
              cert.code
            }}</el-descriptions-item>

            <el-descriptions-item label="标准名称">{{
              cert.professionaltitle
            }}</el-descriptions-item>

            <el-descriptions-item label="标准编号">{{
              cert.certcode
            }}</el-descriptions-item>
            <el-descriptions-item label="证书等级">{{
              cert.professionallevel
            }}</el-descriptions-item>

            <el-descriptions-item label="发证时间">{{
              cert.certtime
            }}</el-descriptions-item>
            <el-descriptions-item label="有效时间">{{
              cert.validtime
            }}</el-descriptions-item>
            <el-descriptions-item label="发证机关">{{
              cert.issuedagency
            }}</el-descriptions-item>
            <el-descriptions-item label="机关网址">{{
              cert.issuedurl
            }}</el-descriptions-item>
            <el-descriptions-item label="年检记录" span="2"
              ><div class="demo-image__placeholder">
                <div
                  v-if="
                    cert.inspectrecord &&
                    cert.inspectrecord.indexOf('第一年') > -1
                  "
                  style="margin-left: 30px"
                >
                  <img
                    :src="`${global.remoteIp}/uploads/sealpic.jpg`"
                    width="150px"
                  />
                  <p
                    style="font-size: 18px; font-weight: 900; margin-left: 43px"
                  >
                    已年审
                  </p>
                </div>
                <div
                  v-if="
                    cert.inspectrecord &&
                    cert.inspectrecord.indexOf('第二年') > -1
                  "
                  style="margin-left: 30px"
                >
                  <img
                    :src="`${global.remoteIp}/uploads/sealpic.jpg`"
                    width="150px"
                  />
                  <p
                    style="font-size: 18px; font-weight: 900; margin-left: 43px"
                  >
                    已年审
                  </p>
                </div>
                <div
                  v-if="
                    cert.inspectrecord &&
                    cert.inspectrecord.indexOf('第三年') > -1
                  "
                  style="margin-left: 30px"
                >
                  <img
                    :src="`${global.remoteIp}/uploads/sealpic.jpg`"
                    width="150px"
                  />
                  <p
                    style="font-size: 18px; font-weight: 900; margin-left: 43px"
                  >
                    已年审
                  </p>
                </div>
              </div></el-descriptions-item
            >
          </el-descriptions>
        </el-card>
      </el-main>
      <el-main
        v-else
        style="width: 100%; max-width: 1170px; margin: auto; overflow: hidden"
      >
        <el-card>
          <el-empty description="未查询到信息"></el-empty>
        </el-card>
      </el-main>
    </el-container>
    <table width="100%"  cellspacing="0" cellpadding="0" style="background: rgb(1, 92, 225);">
        <tbody>
            <tr>
                <td align="center" style="line-height:32px;font-size:15px;color:#FFFFFF;">
                    佰标认证信息查询网<br>
                    信用服务机构业务备案号：JS010704003<br>Copyright &#169; 2016-2021 zgxxw.org.cn Allright
                    sreserved. <a onfocus="this.blur();" class="bai" target="_blank"
                        href="https://beian.miit.gov.cn/">京ICP备16059480号-1</a><br>
                    <table>
                        <tbody>
                            <tr></tr>
                        </tbody>
                    </table>
                </td>
            </tr>
        </tbody>
    </table>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  props: {},
  components: {},
  data() {
    return { global, cert: {}, result: false, restext: "未查询到信息" };
  },

  created() {},

  methods: {},

  computed: {},

  mounted() {
    let code = this.$route.query.code;
    let name = this.$route.query.name;
    let url = "";
    url = `/api/companyCertificates/userget?code=${code}&companyname=${name}`;
    this.$axios
      .get(encodeURI(url))
      .then((res) => {
        if (res.data.data.length > 0) {
          this.cert = res.data.data[0];
          this.result = true;
          this.restext = this.cert.code;
          return;
        } else {
          this.result = false;
          return;
        }
      })
      .catch((err) => {
        this.result = false;
      });
  },

  watch: {},
};
</script>
<style scoped>
/deep/ .el-header {
  padding: 0px;
  background-color: #f5f7fd;
}
/deep/ .el-link.el-link--primary {
  font-size: 16px;
  line-height: 60px;
}
/deep/ .el-icon-arrow-right:before {
  color: #409eff;
}
/deep/ .el-divider--horizontal {
  margin-top: 59px;
}
/deep/ .el-descriptions-item__label.is-bordered-label {
  background-color: #f5f7fd;
  width: 176px;
}
footer {
  background: #f1f1f1;
}
.endnav {
  margin-top: 51px;
}

footer:before {
  background: #34aadc
    linear-gradient(to left, #ffffff, #ffffff, #ffffff, #f9fbfc);
}

element.style {
  text-align: center;
  margin-top: 51px;
}
/* * {
  margin: 0;
  padding: 0;
} */
user agent stylesheet div {
  display: block;
}
.demo-image__placeholder {
  display: -webkit-inline-box;
}

@media screen and (max-width: 600px) {
  .demo-image__placeholder {
    display: block;
  }
}
</style>
